// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.md-list.md-theme-default {\n  padding: 0;\n}\nli.md-list-item.md-menu-item.md-theme-default {\n  margin-bottom: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
